// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__jifUl","compact":"toggle_compact__8AUUT","switch":"toggle_switch__7A3Fo","slider":"toggle_slider__Nlbp9"};